import { createSlice } from "@reduxjs/toolkit";

export const clientCappingSlice = createSlice({
  name: "client-capping",
  initialState: {
    isLoading: false,
    isError: false,
    clientCappingData: [],
    message: "",
    isgetLoading: true,
  },
  reducers: {
    onGetClientCapping: (state) => {
      return {
        ...state,
        isgetLoading: true,
        clientCappingData: [],
        getmessage: "",
      };
    },

    onGetClientCappingSuccess: (state, { payload }) => {
      const { data = [], message = "", status_code = 200 } = payload;
      return {
        ...state,
        isgetLoading: false,
        clientCappingData: data,
        getmessage: message,
        get_status_code: status_code,
      };
    },

    onGetClientCappingError: (state, { payload }) => {
      const { data = [], message = "", status_code = 400 } = payload;
      return {
        ...state,
        clientCappingData: data,
        getmessage: message,
        get_status_code: status_code,
        isgetLoading: false,
      };
    },
    onGetClientCappingReset: (state) => {
      return {
        ...state,
        get_status_code: null,
        isgetLoading: false,
      };
    },
  },
});

export const {onGetClientCapping,
  onGetClientCappingSuccess,
  onGetClientCappingError,
  onGetClientCappingReset
} = clientCappingSlice.actions;

export default clientCappingSlice.reducer;
